//import 'vite/modulepreload-polyfill'
import './main.sass'

import img1 from './images/1.svg';
import img2 from './images/2.svg';
import img3 from './images/3.svg';
import img4 from './images/4.svg';
import burger from './images/burger.svg';
import linkedin from './images/linkedin.svg'
import tiktok from './images/tiktok.svg'
import bannerNewOrders from './images/banner-new-orders.jpg'


document.documentElement.style.setProperty('--burger-icon', `url(${burger})`);


(() => console.log('💙 TamToMy dev was here 👀'))();


(function () {
    const uspItems = document.querySelectorAll("#usp_hp .usp-item");
    const newSrcs = [img1, img2, img3, img4];

    uspItems.forEach((item, index) => {
        const imageWrapper = item.querySelector(".usp-image");
        const linkInImage = imageWrapper?.querySelector("a");
        const img = imageWrapper?.querySelector("img");

        if (linkInImage && img) {
            const imgClone = img.cloneNode(true);
            linkInImage.replaceWith(imgClone);
        }

        const newImg = imageWrapper?.querySelector("img");
        if (newImg && newSrcs[index]) {
            newImg.src = newSrcs[index];
        }

        const textWrapper = item.querySelector(".usp-text");
        const linkInText = textWrapper?.querySelector("a");

        if (linkInText) {
            const span = document.createElement("h5");
            span.innerHTML = linkInText.innerHTML;
            linkInText.replaceWith(span);
        }
    });
})();

//-------------------------------------------

(function () {
    const observer = new MutationObserver(() => {
        const footer = document.querySelector("#footer");
        if (!footer) return;

        const contactWrapper = footer.querySelector(".contact-wrapper");
        const contactDiv = footer.querySelector(".contact-div");
        const lastItem = footer.querySelector(".contact-item.last");

        if (!contactWrapper || !contactDiv) return;

        contactWrapper.querySelectorAll("img").forEach((img) => img.remove());

        contactDiv.innerHTML = `
      <p><small>E-mail</small><br><a href="mailto:objednavky@sothys.cz">objednavky@sothys.cz</a></p>
      <p><small>Telefon</small><br><a href="tel:736607275">+420 736 607 275</a></p>
    `;

        if (lastItem) {
            lastItem.remove();
        }

        observer.disconnect();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
})();


//---------------------------


(function () {
    const observer = new MutationObserver(() => {
        const loginLink = document.querySelector('a[href="/prihlaseni/"]');
        if (loginLink) {
            loginLink.setAttribute("href", "/login/");
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
})();


//---------------------------

(function () {
    const form = document.getElementById("se-webform-4");
    if (!form) return;

    const body = form.querySelector(".se-body");
    const submit = form.querySelector(".se-submit");
    const header = form.querySelector(".se-header");

    if (body && submit) {
        const customBlock = document.createElement("div");
        customBlock.classList.add("custom-form-info");
        customBlock.innerHTML = `
          <span>
            Všechny položky označené * jsou povinné. Odesláním souhlasíte se <a href="/podminky-ochrany-osobnich-udaju/" style="text-decoration: underline">zpracováním osobních údajů.</a>
          </span>
        `;

        submit.parentNode.insertBefore(customBlock, submit);
    }
    if (header) {
        const description = document.createElement("div");
        description.classList.add("form-description");
        description.innerHTML = `
          <p>
            V případě zájmu o spolupráci se značkou Sothys nám prosím zanechte své údaje. Budeme vás kontaktovat.
          </p>
        `;
        header.appendChild(description);
    }
})();

//------------------------

(function () {
    function appendLineToPaginationWrapper() {
        document.querySelectorAll('.pagination-wrapper').forEach(wrapper => {
            const hasPagination = wrapper.querySelector('.pagination')
            const hasLoader = wrapper.querySelector('.pagination-loader')

            if (hasPagination && hasLoader && !wrapper.querySelector('.pagination_line')) {
                const line = document.createElement('div')
                line.className = 'pagination_line'
                wrapper.appendChild(line)
            }
        })
    }

    appendLineToPaginationWrapper()

    const observer = new MutationObserver(() => {
        appendLineToPaginationWrapper()
    })

    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
})();


//-----------------------


(function () {
    const interval = setInterval(() => {
        const iframe = document.querySelector('.lightwidget-widget');
        if (!iframe || !iframe.parentNode) return;

        const previousSibling = iframe.previousElementSibling;

        if (
            previousSibling &&
            previousSibling.classList.contains('lightwidget-title')
        ) {
            clearInterval(interval);
            return;
        }

        const heading = document.createElement('h2');
        heading.textContent = 'Sledujte nás na Instagramu';
        heading.className = 'lightwidget-title';

        iframe.parentNode.insertBefore(heading, iframe);
        clearInterval(interval);
    }, 100);
})();


//------------------------

(function () {
    const interval = setInterval(() => {
        const errorContainer = document.querySelector('.empty-content-404');
        if (!errorContainer) return;

        const p = errorContainer.querySelector('p');
        if (p && p.textContent.includes('Chyba bude nejspíše na našem přijímači')) {
            p.innerHTML = `
        Chyba bude nejspíše na našem přijímači, proto se zkuste vrátit na
        <a href="/">úvodní stránku</a>,
        nebo kontaktujte naši
        <a href="/kontakty">zákaznickou podporu</a>.
      `;
            clearInterval(interval);
        }
    }, 100);
})();

//----------------------

(function () {
    const btn = document.querySelector('.next-step-finish');
    if (btn) {
        btn.textContent = 'OBJEDNAT S POVINNOSTÍ PLATBY';
    }
})();

//------------------

(function removeAllListenersFromCheckoutSidebar() {
    const oldEl = document.querySelector('#checkoutSidebar');
    if (!oldEl) return;

    const newEl = oldEl.cloneNode(true);

    oldEl.parentNode.replaceChild(newEl, oldEl);
})();

//------------------------

(function () {
    const form = document.querySelector('#register-form');
    if (!form) return;

    const body = form.querySelector(".submit-wrapper");

    const alreadyExists = form.querySelector(".custom-form-info");
    if (body && !alreadyExists) {
        const customBlock = document.createElement("div");
        customBlock.classList.add("custom-form-info");
        customBlock.innerHTML = `
          <span>
            Všechny položky označené * jsou povinné. Odesláním souhlasíte se <a href="/podminky-ochrany-osobnich-udaju/" style="text-decoration: underline">zpracováním osobních údajů.</a>
          </span>
        `;

        body.parentNode.insertBefore(customBlock, body);
    }
})();

//---------------------------

(function () {
    const forms = document.querySelectorAll('#formForgottenPassword, .user-action-login, #formLogin');
    if (!forms.length) return;

    forms.forEach(form => {
        const body = form.querySelector(".login-wrapper");

        const alreadyExists = form.querySelector(".custom-form-info");

        if (body && !alreadyExists) {
            const customBlock = document.createElement("div");
            customBlock.classList.add("custom-form-info");
            customBlock.innerHTML = `
              <span style="color: white">
                Všechny položky označené * jsou povinné. Odesláním souhlasíte se 
                <a href="/podminky-ochrany-osobnich-udaju/" style="text-decoration: underline; color: white">
                  zpracováním osobních údajů.
                </a>
              </span>
            `;

            body.parentNode.insertBefore(customBlock, body);
        }
    });
})();


(function () {
    const observer = new MutationObserver(() => {
        const widget = document.querySelector('.lightwidget-widget');
        const footer = document.querySelector('#footer');
        if (widget && footer && footer.parentNode) {
            footer.parentNode.insertBefore(widget, footer);
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();


const helper = document.querySelector('.menu-helper')
const menu = document.querySelector('.menu-level-1')

helper.addEventListener('click', function (e) {
    e.stopPropagation()
    menu.classList.toggle('is-active')
})

document.addEventListener('click', function (e) {
    if (!menu.contains(e.target) && !helper.contains(e.target)) {
        menu.classList.remove('is-active')
    }
});

document.querySelectorAll('.menu-level-1 li').forEach(li => {
    li.classList.remove('exp', 'splitted')
});


(function () {
    const form = document.querySelector('#formForgottenPassword');
    if (form) {
        const label = form.querySelector('label');
        if (label) {
            label.textContent = 'Váš email *';
        }
    }
})();


(function () {
    const items = document.querySelectorAll('.menu-level-1 li');

    items.forEach(li => {
        if (li.parentElement && li.parentElement.classList.contains('LiDiv')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'LiDiv';

        li.parentNode.insertBefore(wrapper, li);
        wrapper.appendChild(li);
    });
})();

(function () {
    const wrappers = document.querySelectorAll('.menu-level-1 .LiDiv');

    wrappers.forEach(wrapper => {
        const hasSubmenu = wrapper.querySelector('ul.menu-level-2');
        if (!hasSubmenu) return;

        let timeoutId;

        wrapper.addEventListener('mouseover', () => {
            if (window.innerWidth > 768) {
                clearTimeout(timeoutId);
                wrapper.classList.add('showing');
            }
        });

        wrapper.addEventListener('mouseout', (e) => {
            if (window.innerWidth > 768 && !wrapper.contains(e.relatedTarget)) {
                timeoutId = setTimeout(() => {
                    wrapper.classList.remove('showing');
                }, 20);
            }
        });
    });
})();

(function () {
    const contactBox = document.querySelector('.contact-box');
    if (!contactBox) return;

    const name = contactBox.querySelector('[data-testid="contactboxName"]');
    if (name) name.textContent = 'Zákaznická podpora';

    const img = contactBox.querySelector('img');
    if (img) {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 640 512');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.innerHTML = `
      <path d="M544 248l0 3.3 69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5L296 64c-37.1 0-67.6 28-71.6 64l-.4 0 0 120c0 22.1 17.9 40 40 40s40-17.9 40-40l0-72c0 0 0-.1 0-.1l0-15.9 16 0 136 0c0 0 0 0 .1 0l7.9 0c44.2 0 80 35.8 80 80l0 8zM336 192l0 56c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-118.6c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1l160 0c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16l2.7 0c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8l0-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"/>
    `;
        img.replaceWith(svg);
    }
})();

(function () {
    const container = document.querySelector('#footer .custom-footer__articles');
    if (!container) return;

    const uls = container.querySelectorAll('ul');
    if (!uls.length) return;

    const ul = uls[uls.length - 1];
    const lastLi = ul.querySelector('li:last-child');
    const link = lastLi?.querySelector('a');

    if (link) {
        link.href = 'https://sothys.cz/pro-profesionaly/';
        link.target = '_blank';
        link.rel = 'noopener';
    }
})();

document.querySelectorAll('p').forEach(p => {
    if (p.offsetWidth === 0 || p.clientWidth === 0 || p.getBoundingClientRect().width === 0) {
        p.style.display = 'none';
    }
});

document.querySelectorAll('.basic-description').forEach(container => {
    const flexes = Array.from(container.querySelectorAll('.dm-flex'));

    const marked = flexes.filter(el =>
        el.classList.contains('one') ||
        el.classList.contains('two') ||
        el.classList.contains('three')
    );

    const others = flexes.filter(el => !marked.includes(el));

    if (flexes.length === 2 && marked.length === 1 && others.length === 1) {
        const target = others[0];
        target.style.display = 'flex';
        target.style.width = '100%';
        target.style.justifyContent = 'space-between';
        target.style.gap = '4rem';
        return;
    }

    if (flexes.length > 2 && marked.length >= 1 && others.length >= 1) {
        others.forEach(flex => {
            flex.style.width = '45%';
        });
        return;
    }

    if (flexes.length === 2 && marked.length === 0) {
        flexes.forEach(flex => {
            flex.style.width = '45%';

        });
    }
});


(function () {
    document.querySelectorAll('.basic-description').forEach(container => {
        container.querySelectorAll('p').forEach(el => {
            const html = el.innerHTML.trim();
            const text = el.textContent.trim();

            if (
                text === '' ||
                html === '&nbsp;' ||
                html === '&#160;' ||
                html === '<br>' ||
                html === '<br/>' ||
                html === '<br />'
            ) {
                el.remove();
            }
        });
    });
})();

(function () {
    function addFooterSocials() {
        const socialsWrapper = document.querySelector('.socials_wrapper')
        if (!socialsWrapper) return false

        const hasLinkedin = !!socialsWrapper.querySelector('a[href*="linkedin.com"]')
        const hasTiktok = !!socialsWrapper.querySelector('a[href*="tiktok.com"]')

        if (!hasLinkedin) {
            const linkedinLink = document.createElement('a')
            linkedinLink.href = 'https://www.linkedin.com/company/sothysczech/'
            linkedinLink.target = '_blank'
            linkedinLink.rel = 'noopener'
            linkedinLink.innerHTML = `<img src="${linkedin}" alt="LinkedIn">`
            socialsWrapper.appendChild(linkedinLink)
        }

        if (!hasTiktok) {
            const tiktokLink = document.createElement('a')
            tiktokLink.href = 'https://www.tiktok.com/@sothysczech?lang=cs-CZ'
            tiktokLink.target = '_blank'
            tiktokLink.rel = 'noopener'
            tiktokLink.innerHTML = `<img src="${tiktok}" alt="TikTok">`
            socialsWrapper.appendChild(tiktokLink)
        }

        return true
    }

    if (addFooterSocials()) return

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addFooterSocials)
    } else {
        addFooterSocials()
    }

    const mo = new MutationObserver(() => {
        if (addFooterSocials()) mo.disconnect()
    })
    mo.observe(document.body, { childList: true, subtree: true })
})();


(function stripBtnClasses() {
    const SELECTOR = '.pagination__link--prev, .pagination__link--next';

    const run = () => {
        document.querySelectorAll(SELECTOR).forEach(el => {
            el.classList.remove('btn', 'btn-secondary');
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }

    const mo = new MutationObserver(() => run());
    mo.observe(document.documentElement, { childList: true, subtree: true });
})();


(function fixProductsLayout() {
    const container = document.getElementById('products')
    if (!container) return

    if (container.classList.contains('products-inline')) {
        container.classList.remove('products-inline')
        container.classList.add('products-block')
    }

    container.querySelectorAll('.products-inline').forEach(el => {
        el.classList.remove('products-inline')
        el.classList.add('products-block')
    })
})();


(function () {
    function moveFlagsIntoImage(root) {
        (root || document).querySelectorAll('.product').forEach(product => {
            const link = product.querySelector('a.image')
            if (!link) return

            const flagsList = product.querySelectorAll('.p-in .flags, .p-in .flags-default, .flags-default, .flags')
            flagsList.forEach(flags => {
                if (!link.contains(flags)) {
                    link.appendChild(flags)
                }
            })
        })
    }

    const productsRoot = document.getElementById('products') || document
    moveFlagsIntoImage(productsRoot)

    const observer = new MutationObserver(mutations => {
        if (observer._pending) return
        observer._pending = true
        requestAnimationFrame(() => {
            mutations.forEach(m => {
                m.addedNodes.forEach(node => {
                    if (node.nodeType === 1) moveFlagsIntoImage(node)
                })
            })
            observer._pending = false
        })
    })

    observer.observe(productsRoot, { childList: true, subtree: true })
})();


(function () {
    function movePCodeUnderP(root) {
        (root || document).querySelectorAll('.product .p').forEach(p => {
            const pIn = p.querySelector('.p-in')
            const pCode = p.querySelector('.p-code')
            if (pIn && pCode && pCode.parentElement !== p) {
                pIn.insertAdjacentElement('afterend', pCode)
            }
        })
    }

    const productsRoot = document.getElementById('products') || document
    movePCodeUnderP(productsRoot)

    const observer = new MutationObserver(mutations => {
        if (observer._pending) return
        observer._pending = true
        requestAnimationFrame(() => {
            mutations.forEach(m => {
                m.addedNodes.forEach(node => {
                    if (node.nodeType === 1) movePCodeUnderP(node)
                })
            })
            observer._pending = false
        })
    })

    observer.observe(productsRoot, { childList: true, subtree: true })
})();


(function unifySearchEverywhere() {
    function ensureLupa() {
        if (!$('.lupa').length) {
            $('<div class="lupa"></div>').prependTo('.header-top > div:last-child');
        }
        return $('.lupa');
    }

    let $searchForm = $('.search .search-form').first();
    if (!$searchForm.length) $searchForm = $('.search-form').first();

    function placeInLupa() {
        const $lupa = ensureLupa();
        if ($searchForm && $searchForm.length && !$searchForm.closest('.lupa').length) {
            $searchForm.appendTo($lupa);
        }
    }

    const observer = new MutationObserver(() => {
        if (!$('.lupa .search-form').length) {
            const $any = $('.search-form').first();
            if ($any.length) $searchForm = $any;
            placeInLupa();
        }
    });

    function start() {
        placeInLupa();
        observer.observe(document.body, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
        start();
    }

    let rTO;
    window.addEventListener('resize', () => {
        clearTimeout(rTO);
        rTO = setTimeout(placeInLupa, 150);
    });
})();

(function searchOnSecondTapLupaOnly() {
    function submitFrom(el) {
        let $form = $(el).find('.search-form').first();
        if (!$form.length) $form = $('.search-form').first();
        if (!$form.length) return;

        const $q = $form.find('input[type="search"], input[name="string"], .query-input').first();

        if (typeof window.checkMinimalLength === 'function') {
            if (!$q.length || !window.checkMinimalLength($q)) return;
        }
        $form.trigger('submit');
    }

    function onActivateFactory(el) {
        return function onActivate(e) {
            if (!document.body.classList.contains('search-visible')) return;

            if (e.target !== el) return;
            if (e.target.closest && e.target.closest('input[type="search"], .search-form')) return;

            e.preventDefault?.();
            e.stopPropagation?.();
            e.stopImmediatePropagation?.();

            submitFrom(el);
        };
    }

    function wire(el) {
        const handler = onActivateFactory(el);

        el.addEventListener('pointerup', handler, { capture: true });
        el.addEventListener('touchend', handler, { capture: true, passive: false });
        el.addEventListener('click', handler, { capture: true });

        el.__lupaWired = true;
    }

    function initAll() {
        document.querySelectorAll('.lupa').forEach(el => {
            if (!el.__lupaWired) wire(el);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
        initAll();
    }

    const mo = new MutationObserver(() => initAll());
    mo.observe(document.body, { childList: true, subtree: true });
})();


///--------------------

(function () {
    if (window.__ariaExpandedLockInstalled) return
    window.__ariaExpandedLockInstalled = true

    var BP = 768

    function isMobile() {
        return window.innerWidth < BP
    }

    function matches(el, sel) {
        var p = Element.prototype
        var fn = p.matches || p.msMatchesSelector || p.webkitMatchesSelector
        return fn ? fn.call(el, sel) : false
    }

    function isLockedLink(el) {
        // jen top-level odkazy v hlavním menu
        return el && el.nodeType === 1 && matches(el, '.menu-level-1 a[aria-haspopup="true"]')
    }

    function hardLockDom() {
        if (!isMobile()) return
        var links = document.querySelectorAll('.menu-level-1 a[aria-expanded]')
        for (var i = 0; i < links.length; i++) links[i].setAttribute('aria-expanded', 'false')
        document.body.classList.remove('submenu-visible')
    }

    // 1) Hard block: nedovol změnit aria-expanded na těchto odkazech
    var _setAttribute = Element.prototype.setAttribute
    Element.prototype.setAttribute = function (name, value) {
        if (isMobile() && name === 'aria-expanded' && isLockedLink(this)) {
            return _setAttribute.call(this, name, 'false')
        }
        return _setAttribute.call(this, name, value)
    }

    var _removeAttribute = Element.prototype.removeAttribute
    Element.prototype.removeAttribute = function (name) {
        if (isMobile() && name === 'aria-expanded' && isLockedLink(this)) {
            return _setAttribute.call(this, 'aria-expanded', 'false')
        }
        return _removeAttribute.call(this, name)
    }

    // 2) Event block: zastav Shoptet handlery ještě před nimi (hlavně iOS “hover přes tap”)
    function block(e) {
        if (!isMobile()) return
        var t = e.target
        if (!t) return
        // trefit link nebo vnořený element uvnitř linku
        var a = t.closest ? t.closest('.menu-level-1 a[aria-haspopup="true"]') : null
        if (!a) return

        // zamknout a uklidit body class
        a.setAttribute('aria-expanded', 'false')
        document.body.classList.remove('submenu-visible')

        // stopnout Shoptet toggler, ale NErušit default proklik (nevoláme preventDefault)
        e.stopImmediatePropagation()
        e.stopPropagation()
    }

    // tohle je typicky to, co iOS Safari spouští místo “hover”
    window.addEventListener('pointerdown', block, true)
    window.addEventListener('touchstart', block, true)
    window.addEventListener('mousedown', block, true)
    window.addEventListener('mouseover', block, true)
    window.addEventListener('focusin', block, true)

    // 3) Pojistka: kdyby se submenu-visible i tak objevilo, smaž ho hned (bez čekání)
    var bodyObs = new MutationObserver(function () {
        if (!isMobile()) return
        if (document.body.classList.contains('submenu-visible')) {
            document.body.classList.remove('submenu-visible')
        }
    })
    bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] })

    document.addEventListener('DOMContentLoaded', hardLockDom)
    window.addEventListener('resize', hardLockDom)
    window.addEventListener('orientationchange', hardLockDom)
})();


//--------------------

/**
 * Opens a modal dialog that is removed from the DOM once closed.
 */
function openModal(className, html) {
    const dialog = document.createElement('dialog')
    dialog.className = `banner-modal ${className}`
    dialog.innerHTML = `
        <button type="button" class="banner-modal__close" aria-label="Zavřít">&times;</button>
        ${html}
    `

    dialog.querySelector('.banner-modal__close').addEventListener('click', () => dialog.close())
    dialog.addEventListener('click', e => {
        if (e.target === dialog) dialog.close()
    })
    dialog.addEventListener('close', () => dialog.remove())

    document.body.appendChild(dialog)
    dialog.showModal()

    return dialog
}

(function newOrdersBannerModal() {
    const STORAGE_KEY = 'sothys-banner-new-orders-seen'

    if (!location.pathname.startsWith('/klient/')) return

    try {
        if (localStorage.getItem(STORAGE_KEY)) return
    } catch (e) {
        return
    }

    const dialog = openModal('banner-modal--image', `
        <img src="${bannerNewOrders}" width="750" height="500" alt="Nově vaše objednávky odesíláme každý den. Platí pro objednávky vytvořené přes e-shop.">
    `)

    dialog.addEventListener('close', () => {
        try {
            localStorage.setItem(STORAGE_KEY, '1')
        } catch (e) {}
    })
})();

(function videoGuideBanner() {
    const YOUTUBE_ID = 'DoA1xwbRYIc'

    if (location.pathname !== '/klient/') return

    const heading = document.querySelector('.content-inner h1') || document.querySelector('h1')
    if (!heading || document.querySelector('.video-banner')) return

    const thumbnail = YOUTUBE_ID ? `https://i.ytimg.com/vi/${YOUTUBE_ID}/hqdefault.jpg` : bannerNewOrders

    const banner = document.createElement('div')
    banner.className = 'video-banner'
    banner.innerHTML = `
        <button type="button" class="video-banner__thumb" aria-label="Přehrát videonávod">
            <img src="${thumbnail}" alt="" loading="lazy">
            <span class="video-banner__play" aria-hidden="true"></span>
        </button>
        <div class="video-banner__content">
            <h3 class="video-banner__title">Jak objednávat na našem e&#8209;shopu</h3>
            <p class="video-banner__text">Krátký videonávod k objednávce a použití slevového kupónu.</p>
            <button type="button" class="btn btn-primary video-banner__cta">Přehrát videonávod</button>
        </div>
    `

    const openVideo = () => openModal('banner-modal--video', YOUTUBE_ID
        ? `<div class="banner-modal__video">
               <iframe src="https://www.youtube-nocookie.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0" title="Jak objednávat na našem e-shopu" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>
           </div>`
        : `<div class="banner-modal__placeholder">Videonávod pro vás právě připravujeme.</div>`
    )

    banner.querySelectorAll('.video-banner__thumb, .video-banner__cta').forEach(el => el.addEventListener('click', openVideo))

    heading.insertAdjacentElement('afterend', banner)
})();
